import React from 'react';

export const NoRecords: React.FC = () => {
  return (
    <div
      className={
        'd-flex justify-content-center align-items-center flex-column text-muted gap-2'
      }>
      <span
        className={'material-symbols-outlined'}
        style={{ fontSize: '32px' }}>
        zone_person_alert
      </span>
      <span>No data found</span>
    </div>
  );
};
